import glamorous from 'glamorous';
import Chip from 'react-toolbox/lib/chip';

export const PriceList = glamorous.div({
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  marginBottom: '8px',
  '@media screen and (min-width: 768px)': {
    alignItems: 'stretch',
    '& + div': {
      marginLeft: '4rem',
    },
  },
});

export const PriceListContainer = glamorous.div({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
  },
  '@media screen and (max-width: 767px)': {
    flexDirection: 'column',
  },
});

export const PriceChip = glamorous(Chip, {
  rootEl: 'div',
  forwardProps: Object.keys(Chip.propTypes),
})(
  {
    paddingLeft: '0px !important',
    marginBottom: '8px',
    ':hover': {
      cursor: 'pointer',
    },
    '@media screen and (min-width: 768px)': {
      maxWidth: '100% !important',
    },
    '@media screen and (max-width: 767px)': {
      width: '100%',
    },
  },
  ({ active, color, lightenAmt }) => {
    if (active) {
      return {
        color: '#333333',
        backgroundColor: '#d1f1de !important',
      };
    }
  }
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/RegistrationForm/PriceChipList/styles.js